import React from "react";
import { Box, Typography } from "@mui/material";
import { CheckIcon, PendingIcon } from "assets";
import Colors from "assets/Style/Colors";

const normalizeStatus = (status) =>
  (status ?? "").toString().trim().toLowerCase();

const getMeta = (status) => {
  const key = normalizeStatus(status);

  if (key === "paid") {
    return { label: "Paid", kind: "paid" };
  }

  if (key === "partial") {
    return { label: "Partial", kind: "partial" };
  }

  if (key === "pending") {
    return { label: "Pending", kind: "pending" };
  }

  if (key === "unpaid") {
    return { label: "Pending", kind: "pending" };
  }

  return { label: status ? String(status) : "-", kind: "unknown" };
};

export default function PaymentStatus({ status }) {
  const { label, kind } = getMeta(status);
  const isPartial = kind === "partial";
  const isPending = kind === "pending";
  const isPaid = kind === "paid";

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.75,
        ...(isPartial ? { path: { fill: Colors.bluishCyan } } : null),
      }}
    >
      {isPaid || isPartial ? (
        <CheckIcon />
      ) : isPending ? (
        <PendingIcon />
      ) : null}
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        {label}
      </Typography>
    </Box>
  );
}
